"use strict";
/** Live Louvre corridor report returned by GET /api/louvre/corridors. */
Object.defineProperty(exports, "__esModule", { value: true });
